<div class="bg-third-level rounded border-l-4 border-blue-400 p-3 text-sm">
  <ng-content />
</div>
